import constants from "constants";

const { SHOW_MODAL, HIDE_MODAL, UPDATE_MODAL_DATA } = constants;

const modal = (
  modal = {
    modalType: null,
    modalContentProps: {}
  },
  action
) => {
  switch (action.type) {
    case SHOW_MODAL:
      return {
        modalType: action.modalType,
        modalContentProps: action.modalContentProps
      };
    case HIDE_MODAL:
      return {
        modalType: null,
        modalContentProps: {}
      };
    case UPDATE_MODAL_DATA:
      return {
        modalType: action.modalType,
        modalContentProps: {
          users: action.users,
          additional: action.additional
        }
      };
    default:
      return modal;
  }
};

export { modal };



/** WEBPACK FOOTER **
 ** ./src/reducers/modal.js
 **/